import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Select } from 'antd';
import {
  getAuthStatus,
  AuthStatus,
  updateIntegration,
} from '../../api/MarketplaceAuth';

const availableOptions = ['wildberries', 'ozon', 'ozon_fresh'].map((el) => ({
  value: el,
  label: el,
}));

const AuthMarketplace = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<AuthStatus[]>([]);
  const [select, setSelect] = useState<{
    value: string;
    label: string;
  } | null>(null);
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);

  const options = availableOptions.filter(
    (el) => !state.some((s) => s.markerplace === el.value),
  );

  const reload = () => getAuthStatus().then((res) => setState(res));

  useEffect(() => {
    reload();
  }, []);

  const addIntegration = async () => {
    if (!select) return;
    setPending(true);
    setError('');
    try {
      await updateIntegration({ markeplace: select.value });
      await reload();
      const marketplace = select.value;
      setSelect(null);
      navigate(`/settings/auth_marketplace/${marketplace}`);
    } catch (e: any) {
      setError(e?.message || 'Не удалось создать интеграцию');
    } finally {
      setPending(false);
    }
  };

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <h4 style={{ margin: '16px 0 24px' }}>Интеграции маркетплейсов</h4>
        </Col>
      </Row>

      {options.length ? (
        <Row className="mb-4">
          <Col xs={12} md={6}>
            <Select
              style={{ width: '100%' }}
              placeholder="Выбрать маркетплейс"
              options={options}
              value={select}
              labelInValue
              onChange={(v) => setSelect(v)}
            />
          </Col>
          <Col xs={12} md="auto">
            <Button onClick={addIntegration} disabled={!select || pending}>
              Добавить интеграцию
            </Button>
          </Col>
        </Row>
      ) : null}

      {error && (
        <Row className="mb-3">
          <Col style={{ color: 'crimson' }}>{error}</Col>
        </Row>
      )}

      <Row>
        {state.map((el) => (
          <Col key={el.markerplace} xs={12} md={6} lg={4} className="mb-3">
            <Card>
              <Card.Body>
                <Card.Title>{el.markerplace}</Card.Title>
                <Card.Text style={{ marginBottom: 12, color: '#666' }}>
                  Seller Id: {el.sellerId || '—'}
                </Card.Text>
                <Link to={`/settings/auth_marketplace/${el.markerplace}`}>
                  <Button size="sm">Открыть</Button>
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
        {!state.length && <Col>Нет интеграций</Col>}
      </Row>
    </Container>
  );
};

export default AuthMarketplace;
